(function(angular) {
    'use strict';

    angular.module('aprima-bridge').factory('CustomModuleRunService', [
        '$injector',
        CustomModuleRunService,
    ]);

    function CustomModuleRunService(
        $injector
    ) {
        var hasRun = false;
        var runFns = [];

        return {
            add: add,
            run: run,
        };

        function add(fn) {
            if (hasRun) {
                throw new Error('CustomModuleRunService has already run');
            }
            runFns.push(fn);
        }

        function run() {
            if (hasRun) {
                throw new Error('CustomModuleRunService has already run');
            }
            hasRun = true;
            runFns.forEach($injector.invoke);
        }
    }
})(window.angular);
